"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withLinkCache;

var _withCache = _interopRequireDefault(require("./withCache"));

var linkCache = {};

function withLinkCache(WrappendComponent) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : linkCache;
  return (0, _withCache.default)(cache)(WrappendComponent);
}

module.exports = exports.default;